if (!customElements.get('component-country-drawer')) {
  customElements.define(
    'component-country-drawer',
    class CountryDrawer extends HTMLElement {
      constructor() {
        super();
      }


      connectedCallback() {
        this.defineElements();

        if (!this.form || !this.input || !this.links)  {
          return null;
        }


        this.addListeners();
      }

      addListeners() {
        this.links.forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      defineElements() {
        this.form = this.querySelector('form');
        this.input =  this.querySelector( 'input[name="country_code"]');
        this.links = this.querySelectorAll('[data-js-link]');
      }

      onItemClick(event) {
        event.preventDefault();

        this.input.value = event.currentTarget.dataset.value;
        this.form.submit();
      }
    }
  );
}
